import { IS_WHITE_LABEL } from '@/shared/environments';
import { isTrackingDisabled } from '@/shared/lib/isTrackingDisabled';

export const ADS_CONSENT_EVENTS = ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline'] as const;

const readyConsent = new WeakSet<object>();
ADS_CONSENT_EVENTS.forEach((name) => {
  window.addEventListener(name, () => {
    if (window.Cookiebot) readyConsent.add(window.Cookiebot);
  });
});

export const getAdsMarketingConsent = (): boolean | undefined => {
  if (IS_WHITE_LABEL || isTrackingDisabled()) return false;
  const cookiebot = window.Cookiebot;
  if (!cookiebot?.consent || (!cookiebot.hasResponse && !readyConsent.has(cookiebot))) return;
  return cookiebot.consent.marketing === true;
};
